import React from 'react';
import { addTransactionVoucherAction } from '../../ducks/cart';
import { selectTransactionVouchers } from '../../ducks';
import { AppState } from '../../../../common/models/AppState';
import { connect } from 'react-redux';
import DiscountVoucher from '../discount-voucher/discount-voucher';
import { i18n } from '../../../../common/services/i18n';

interface DispatchToProps {
    setTransactionVouchers: (payload: string[]) => void;
}

interface StateToProps {
    vouchers: string[];
}

type DiscountVoucherListProps = DispatchToProps & StateToProps;

const DiscountVoucherList = ({ vouchers }: DiscountVoucherListProps) => {
    return (
        <div className="discount-voucher-list__container">
            <div className="control__label">{i18n.t('informations.discountVoucher.label')}</div>
            {(vouchers || []).map((voucher) => (
                <DiscountVoucher key={voucher} voucher={voucher} />
            ))}
            <DiscountVoucher />
        </div>
    );
};

const mapDispatchToProps: DispatchToProps = {
    setTransactionVouchers: addTransactionVoucherAction,
};

const mapStateToProps = (state: AppState): StateToProps => ({
    vouchers: selectTransactionVouchers(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountVoucherList);
